import { ApeironLinkButton, DEFAULT_ANIMATE_DURATION } from '@apeiron/temp'
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded'
import { Box, styled, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

const BackButton = styled(ApeironLinkButton)`
  align-items: center;
  display: flex;
  flex-direction: column;
  left: 40px;
  padding: 6px;
  position: fixed;
  row-gap: 10px;
  border-radius: 6px;
  top: 150px;
  z-index: 1;

  ${props => props.theme.breakpoints.down('res768')} {
    left: 20px;
  }

  ${props => props.theme.breakpoints.up('res1920')} {
    left: calc(50% - 800px);
  }

  :hover p {
    opacity: 1;
    margin-top: unset;
  }
`

const BackIconContainer = styled(Box)`
  align-items: center;
  aspect-ratio: 1;
  background-color: #d9d9d9;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  width: 40px;
`

const BackText = styled(Typography)`
  transition: opacity ${DEFAULT_ANIMATE_DURATION}ms,
    margin-top ${DEFAULT_ANIMATE_DURATION}ms;

  background: black;
  border-radius: 8px;
  line-height: 16px;
  opacity: 0;
  margin-top: -10px;
  padding: 4px 10px;
`

const BackIcon = styled(ArrowBackIosNewRoundedIcon)`
  color: black;
`

type Props = {
  href: string
}

const PageBuilderBackButton = ({ href }: Props) => {
  const { t } = useTranslation()

  return (
    <BackButton url={href}>
      <BackIconContainer>
        <BackIcon />
      </BackIconContainer>
      <BackText>{t('common.button.back')}</BackText>
    </BackButton>
  )
}

export default PageBuilderBackButton
